var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:`echart-${_vm._uid}`,staticClass:"container",attrs:{"id":`echart-${_vm._uid}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }